import { parsePhoneNumberFromString } from "libphonenumber-js";

function parsePhone(phone: string) {
  const str = String(phone).trim();
  if (!str || !str.startsWith("+")) {
    throw new Error(`Invalid phone number: ${str}`);
  }

  const parsed = parsePhoneNumberFromString(str, "SA");
  if (!parsed || !parsed.isValid()) {
    throw new Error(`Invalid phone number: ${str}`);
  }

  return parsed;
}

export const usePhoneHelpers = () => {
  const phoneDisplay = (phone: string): string => parsePhone(phone).formatInternational();

  const phoneWhatsapp = (phone: string): string => {
    const digits = parsePhone(phone).format("E.164").replace(/\D/g, "");
    return `https://wa.me/${digits}`;
  };

  return {
    phoneDisplay,
    phoneWhatsapp,
  };
};
